module.exports = __webpack_public_path__ + "mindsetn-075cad3e.webp";